import ConfigWrapper from "../../widget/ConfigWrapper";
import CustomToggleButtons from "./CustomToggleButtons";
import CustomInputField from "./CustomInputField";
import { BUTTONS_INFO, INPUT_VALIDATION } from "../CartConfigurationUtils";
import { Autocomplete, TextField, Stack } from "@mui/material";
import {
  CustomRadio,
  FeaturesCheckbox,
} from "../../widget/FearturesInputTypes/FeatureInputs";
interface CartConfigMainLogicPropsNew {
  values: any;
 updateValues: React.Dispatch<React.SetStateAction<any>>;
  avalableBuckets: { id: string; title: string }[];
  savedRole: string;
  isSaveAttempted: boolean;
}
const CartConfigMainLogicNew: React.FC<CartConfigMainLogicPropsNew> = ({
  values,
  updateValues,
  avalableBuckets,
  savedRole,
  isSaveAttempted,
}) => {
  const buttonsInfo = BUTTONS_INFO;
  // const criteriaForOrderingCondition = CRITERIA_FOR_ORDERING_CONDITION;
  const inputValidation = INPUT_VALIDATION;
  const handleValueChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    // ;
    const { name, value } = e.target;
    let newValues = { ...values, [name]: value };
    if (name === "orderValidationType") {
      if (value.split(",").length === 2) {
        if (values?.orderingCriteriaType?.split(",").length > 1) {
          newValues = {
            ...newValues,
            orderingCriteriaType: values?.orderingCriteriaType?.split(",")[1],
          };
        }
      }
    }
    if (name === "orderingCriteriaType") {
      const orderingValidationTypeCriteriaCondition =
        value?.split(",").length === 3 ? value?.split(",")[2] : null;
      newValues = {
        ...newValues,
        orderingValidationTypeCriteriaCondition:
          orderingValidationTypeCriteriaCondition,
      };
    }
    if (name === "missedProductCarouselOption"){
      // if values's missedItemBasketId doesn't exist in the availableBuckets then set it to availableBuckets[0]?.id
      if (value === "Personalised Curated Basket" && !avalableBuckets?.some((bucket) => bucket?.id === newValues?.missedItemBasketId) && avalableBuckets?.length>0) {
        newValues = {
          ...newValues,
          missedItemBasketId: avalableBuckets[0]?.id,
        };
      }
    }
    if (name === "persistentCartNavigationBar" && e.target instanceof HTMLInputElement){
      newValues ={
        ...newValues,
        persistentCartNavigationBar: e.target.checked
      }
    }
    updateValues(newValues);
  };

  const handleCheckChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const keyName = e.target.name;
    updateValues({
      ...values,
      [keyName]: {
        ...values[keyName],
        value: e.target.checked,
        isValueUpdated: true,
        domainType: "order_configuration",
      },
    });
  };
  const handleDropDownChange = (event: any, newValue: any) => {
    const newValues = { ...values, missedItemBasketId: newValue.id };
    updateValues(newValues);
  };
  return (
    <div className="config-main">
      <ConfigWrapper
        heading="Delivery Date"
        customStyles={{ marginTop: "0rem" }}
      >
        <>
          <CustomToggleButtons
            title="Select the input type of delivery date"
            handleToggleChangeEvent={handleValueChange}
            values={values}
            buttonsInfo={buttonsInfo.deliveryDateType}
          />
          {values.deliveryDateType === "Number" ? (
            <CustomInputField
              label="Number of days to display for the delivery:"
              type="number"
              values={values}
              name="deliveryDateValueNumber"
              inputValidation={inputValidation.deliveryDateValue.number}
              handleInputChange={handleValueChange}
              isSaveAttempted={isSaveAttempted}
              placeholder={"Number of days"}
            />
          ) : (
            <CustomInputField
              label="Text to display for the delivery:"
              type="string"
              values={values}
              name="deliveryDateValueText"
              inputValidation={inputValidation.deliveryDateValue.text}
              handleInputChange={handleValueChange}
              isSaveAttempted={isSaveAttempted}
              placeholder={"Text to display"}
            />
          )}
        </>
      </ConfigWrapper>
      <ConfigWrapper heading="Missed Product Carousel">
        <>
          <CustomToggleButtons
            title="Add a missed product carousal on the cart page?"
            handleToggleChangeEvent={handleValueChange}
            values={values}
            buttonsInfo={
              savedRole === "retailer"
                ? buttonsInfo.missedProductCarouselEnabledRetailer
                : buttonsInfo.missedProductCarouselEnabledSalesRep
            }
          />
          {((savedRole === "retailer" &&
            values.missedProductCarouselEnabledRetailer === "true") ||
            (savedRole === "salesrep" &&
              values.missedProductCarouselEnabledSalesRep === "true")) &&
            savedRole === "retailer" && (
              <>
                <CustomToggleButtons
                  title="Which SKU should be visible in the carousal?"
                  handleToggleChangeEvent={handleValueChange}
                  values={values}
                  buttonsInfo={buttonsInfo.missedProductCarouselOptions}
                />
                {values.missedProductCarouselOption ===
                  "Personalised Curated Basket" && (
                  //create a drop down of the available baskets
                  <Autocomplete
                    disableClearable
                    options={avalableBuckets}
                    getOptionLabel={(option) => option.title}
                    value={
                      avalableBuckets.find(
                        (bucket) => bucket.id === values.missedItemBasketId
                      ) || undefined
                    }
                    onChange={handleDropDownChange}
                    renderInput={(params) => (
                      <TextField
                        sx={{
                          "& .MuiInputBase-root": {
                            fontSize: "14px",
                          },
                          "& .MuiFormLabel-root": {
                            fontSize: "14px",
                            marginTop: "-4px",
                            "&.MuiInputLabel-shrink": {
                              marginTop: "0",
                            },
                          },
                        }}
                        {...params}
                        label="Select basket"
                        variant="outlined"
                      />
                    )}
                    sx={{
                      "& .MuiAutocomplete-inputRoot": {
                        padding: "4px",
                      },
                      marginTop: "5px",
                      width: "250px",
                    }}
                  />
                )}
              </>
            )}
        </>
      </ConfigWrapper>
      <ConfigWrapper heading="Ordering Validation">
        <>
          <CustomToggleButtons
            title="Select the type of validation to be implemented while placing orders"
            handleToggleChangeEvent={handleValueChange}
            values={values}
            buttonsInfo={buttonsInfo.orderValidationType}
            popOverContent = {"If the ordering condition data is uploaded manually, it will overwrite the data entered below."}
            // vertical={true}
          />
          <CustomToggleButtons
            title="Select the criteria"
            handleToggleChangeEvent={handleValueChange}
            values={values}
            buttonsInfo={
              values.orderValidationType?.split(",")?.length !== 2
                ? buttonsInfo.orderingCriteriaType
                : buttonsInfo.orderingCriteriaType.filter(
                    (criteria) => criteria.value?.split(",").length === 1
                  )
            }
            // vertical={true}
          />
          {values.orderValidationType
            ?.split(",")
            ?.reverse()
            .map((validationType: string) =>
              values.orderingCriteriaType
                ?.split(",")
                .map((criteriaType: string, index: number) => {
                  //only taking first 2 values because for both ( & or | ) case i am storing the value like ( value,quantity,& ) so it will have 3 values but i need only 2
                  if (index >= 2) return null;

                  const keyToStore = `${validationType}_${criteriaType}`;
                  const isMinValidation = validationType === "min";
                  const isValueCriteria = criteriaType === "value";

                  const label = `Enter default ${
                    isMinValidation ? "minimum" : "maximum"
                  } ${isValueCriteria ? "value" : "quantity"}:`;
                  const placeholder = `Default ${
                    isMinValidation ? "minimum" : "maximum"
                  } ${isValueCriteria ? "value" : "quantity"}`;

                  return (
                    <CustomInputField
                      key={keyToStore}
                      label={label}
                      type="number"
                      values={values}
                      name={keyToStore}
                      inputValidation={inputValidation.minMaxValueQuanitity}
                      handleInputChange={handleValueChange}
                      isSaveAttempted={isSaveAttempted}
                      placeholder={placeholder}
                    />
                  );
                })
            )}
        </>
      </ConfigWrapper>
      
    </div>
  );
};

export default CartConfigMainLogicNew;
